import { take, fork, select, put, call } from 'redux-saga/effects';
import actionTypes from '../actionTypes';
import { callApi } from "./callApi";
import config from '../../config/config';
import { getGlobalAccount } from '../selectors';
import { openDialog } from '../actionCreators/dialog';
import { successDailyBonus } from '../actionCreators/bonus';

function* checkDailyBonus() {
    try {
        const { id: accountId, token, clubId: skinId } = yield select(getGlobalAccount);
        const response = yield call(callApi, `${config.API_URL}/askForBonus`, 'POST', { accountId, skinId, token, type: "login" });
        if (response.data.result.amount) {
            yield put(openDialog('dailyBonus', {amount: response.data.result.amount}));
            yield put(successDailyBonus());
        }
    } catch (e) {}
}

export function* watchDailyBonus() {
    while (true) {
        yield take(actionTypes.DAILY_BONUS_REQUEST);
        yield fork(checkDailyBonus);
    }
}
